export enum TelephoneTypeEnum {
  TELEPHONE = 'TELEPHONE',
  CELLULAIRE = 'CELLULAIRE',
}
